export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9351.3a49ca7b.jpg";